import styled from '@emotion/styled';
import { COLOR_VARIANTS, Icons, color } from '@tajawal/ct-web-design-system';
import { Skeleton as MuiSkeleton } from '@mui/material';
import { CustomTheme } from '@tajawal/ct-web-design-system/dist/theme';

const Skeleton = styled(MuiSkeleton)`
  border-radius: 4px;
`;

const StopsWrapper = styled.div`
  display: flex;
  align-items: center;
  margin: 0px 16px;
  flex-grow: 1;
  & > .MuiDivider-root {
    margin: 0px 4px;
    flex-grow: 1;
  }
`;

const Dot = styled.div`
  width: 4px;
  height: 4px;
  border-radius: 2px;
  background: ${color(COLOR_VARIANTS.GAINSBORO)};
`;

const FlightsIcon = styled(Icons.FlightsIconSolid)`
  transform: ${({ theme }: { theme?: CustomTheme }) => theme.isRtl && 'rotateY(180deg)'};
`;

export default {
  StopsWrapper,
  Dot,
  Skeleton,
  FlightsIcon,
};
